import { FAQItem, FeatureLdg, InfoLdg, StatItem, TestimonialType } from "types";

export const stats: StatItem[] = [
  { value: "100%", label: "Undetected Rate", description: "Bypassing latest anticheat updates" },
  { value: "< 60s", label: "Instant Key Delivery", description: "Automated license dispatch" },
  { value: "24/7", label: "Discord VIP Support", description: "Real-time setup assistance" },
  { value: "5,000+", label: "Active Players", description: "Trusted community worldwide" },
];

export const faqs: FAQItem[] = [
  {
    question: "How do I receive my product key after purchase?",
    answer:
      "All license keys are dispatched automatically and instantly to your Foulware dashboard under 'My Orders'. You can reveal and copy your key immediately after completing checkout.",
  },
  {
    question: "Are your macros and cheats undetected?",
    answer:
      "Yes! Our software utilizes advanced kernel-level drivers and hardware-emulated input methods (Logitech G-HUB & USB microcontroller spoofing) to ensure complete invisibility to game anticheats.",
  },
  {
    question: "Which Windows versions are supported?",
    answer:
      "Our software supports Windows 10 (all versions 20H2+) and Windows 11 (including 22H2, 23H2, and 24H2). Detailed step-by-step setup guides are provided in our documentation.",
  },
  {
    question: "What happens when a game pushes an update?",
    answer:
      "Our engineering team monitors game patches 24/7. When an update drops, our bypass algorithms are refreshed within hours, and existing licenses are frozen/compensated for any maintenance windows.",
  },
  {
    question: "Can I get help setting up my software?",
    answer:
      "Absolutely. We have a dedicated support team on Discord available 24/7 to guide you through configuration, sensitivity tuning, and troubleshooting.",
  },
];

export const infos: InfoLdg[] = [
  {
    title: "Our Core Technology",
    description:
      "Engineered from the ground up for maximum stealth, smooth recoil control, and bulletproof anticheat resistance.",
    image: "/_static/illustrations/work-from-home.jpg",
    list: [
      {
        title: "Hardware Emulation",
        description:
          "Simulates genuine Logitech G-HUB mouse hardware inputs to evade behavioral heuristic detection.",
        icon: "laptop",
      },
      {
        title: "Kernel-Level Protection",
        description:
          "Zero-memory signature bypass methods ensure full stealth on Vanguard, EAC, and BattlEye.",
        icon: "settings",
      },
      {
        title: "Instant Key Fulfillment",
        description:
          "Zero wait times — automated database fulfillment delivers your license within seconds.",
        icon: "keyRound",
      },
    ],
  },
];

export const features: FeatureLdg[] = [
  {
    title: "PUBG 100% Recoil (SE AUTO)",
    description:
      "Flawless automatic weapon compensation with smart weapon detection. Available in Day, Month, and Lifetime plans.",
    link: "/product/macro-1",
    icon: "laptop",
  },
  {
    title: "USB Hardware Macro",
    description:
      "True physical USB microcontroller bypass. Zero software footprint on your primary gaming rig.",
    link: "/product/macro-2",
    icon: "settings",
  },
  {
    title: "PUBG 80% Recoil + FastLoot",
    description:
      "Natural-looking recoil smoothing coupled with ultra-rapid inventory looting hotkeys.",
    link: "/product/macro-3",
    icon: "package",
  },
  {
    title: "FastLoot Utility Macro",
    description:
      "Instant 1-frame container and ground loot pickup for competitive edge during hot drops.",
    link: "/product/macro-4",
    icon: "laptop",
  },
  {
    title: "CS2 GHUB Macro",
    description:
      "Custom spray patterns for AK-47, M4A1-S, and SMGs directly via Logitech G-HUB profiles.",
    link: "/product/macro-5",
    icon: "laptop",
  },
  {
    title: "PUBG Apple Private Build",
    description:
      "Premium DMA & internal suite with high-precision player ESP, item filters, and aim smoothing.",
    link: "/product/cheats-2",
    icon: "page",
  },
];

export const testimonials: TestimonialType[] = [
  {
    name: "KenraaliTumppu",
    job: "PUBG Competitive",
    game: "PUBG",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    review:
      "Hands down the cleanest recoil macro on the market. The SE AUTO script feels completely natural, and instant key delivery on checkout made setup effortless.",
  },
  {
    name: "ApexPredator_99",
    job: "CS2 Faceit / Premier",
    game: "CS2",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    review:
      "The CS2 GHUB macro is insane for spray transfers. Zero ban risk since it runs straight through Logitech software. Support in Discord is 10/10.",
  },
  {
    name: "drock860",
    job: "PUBG Streamer",
    game: "PUBG",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/3.jpg",
    review:
      "Using the USB hardware macro for 4+ months without a single issue. Completely undetectable. Best investment I've made for competitive gaming.",
  },
  {
    name: "ViperTactics",
    job: "Multi-FPS Player",
    game: "PUBG / CS2",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/6.jpg",
    review:
      "Instant activation, easy instructions, and the recoil patterns are laser accurate. The new user dashboard makes accessing and managing keys so smooth!",
  },
  {
    name: "StealthNinja",
    job: "PUBG Veteran",
    game: "PUBG",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/4.jpg",
    review:
      "The fast loot macro alone has saved me dozens of times on hot drops. Great price, immediate key dispatch, and super friendly Discord staff.",
  },
  {
    name: "CyberGhost",
    job: "Verified Buyer",
    game: "All Games",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/14.jpg",
    review:
      "Top-tier vendor. Updates are posted right away after game patches. 100% undetected and legit.",
  },
];
